define('plugins/musicfavourite/ui/dialogs/text',{
    'en-gb': {
        'cannotAddFavourite': 'Sorry we couldn\'t add your Favourite',
        'cannotRemoveFavourite': 'Sorry we couldn\'t remove your Favourite',
        'cannotSendFeedback': 'Sorry we couldn\'t send your feedback',
        'tryAgain': 'Please try again later',
        'technicalDifficulties': 'Sorry, for technical reasons this feature is currently unavailable',
        'close':'close'
    },
    'cy-gb': {
        'cannotAddFavourite': 'Mae\'n ddrwg gennym ond nid oedd modd ychwanegu eich ffefryn',
        'cannotRemoveFavourite': 'Mae\'n ddrwg gennym ond nid oedd modd dileu eich ffefryn',
        'cannotSendFeedback': 'Wedi methu anfon eich adborth',
        'tryAgain': 'Rhowch gynnig arall wedyn',
        'technicalDifficulties': 'Dyw\'r gwasanaeth ddim ar gael ar hyn o bryd am resymau technegol',
        'close':'close'
    },
    'ga-gb': {
        'cannotAddFavourite': 'Ar an drochuair, n&iacute;orbh fh&eacute;idir sin a chur le do Chean&aacute;in',
        'cannotRemoveFavourite': 'Ar an drochuair n&iacute;orbh fh&eacute;idir sin a bhaint de do Chean&aacute;in.',
        'cannotSendFeedback': 'Buartha, n&iacute; raibh muid &aacute;balta d\'aischoth&uacute; a sheoladh',
        'tryAgain': 'Bain triail as ar&iacute;s ar ball',
        'technicalDifficulties': 'Buartha, ach ar ch&uacute;iseanna teicni&uacute;la n&iacute;l an ghn&eacute; seo ar f&aacute;il faoi l&aacute;thair',
        'close':'close'
    },
    'gd-gb': {
        'cannotAddFavourite': 'Duilich, cha b\' urrainn dhuinn an Roghainn agad a chur ris',
        'cannotRemoveFavourite': 'Duilich, cha b\' urrainn dhuinn an Roghainn agad a thoirt &aacute;s',
        'cannotSendFeedback': 'Duilich, cha b\' urrainn dhuinn do bhrath a chur air falbh',
        'tryAgain': 'Feuch an ceann &ugrave;ine',
        'technicalDifficulties': 'Duilich, ri linn trioblaidean teicnigeach chan eil seo ri fhaotainn an-dr&aacute;sta',
        'close':'close'
    }
});
